// 0–100 rating scale per spec v2 lines 174-182.
// Thresholds are inclusive lower bounds, evaluated top-down so fractional
// values in former bracket gaps (e.g. 89.3) bucket correctly.
const EXCELLENT = { hex: '#10B981', label: 'Excellent' };
const GOOD =      { hex: '#22C55E', label: 'Good' };
const AVERAGE =   { hex: '#EAB308', label: 'Average' };
const BELOW =     { hex: '#F97316', label: 'Below Average' };
const POOR =      { hex: '#EF4444', label: 'Poor' };

const UNKNOWN = { hex: '#9CA3AF', label: '—' };

// `tone` controls how value maps to color severity. Default is "quality" — used
// for accuracy / mention / sentiment scores where 100 is great (green) and 0
// is bad (red). For threat scores the polarity is reversed: 100 means very
// threatening (alarming red), 0 means harmless (calm green) — pass tone="threat"
// (markup #110).
export function bucketFor(value, { tone = 'quality' } = {}) {
  if (value == null || Number.isNaN(Number(value))) return UNKNOWN;
  const v = Number(value);
  if (tone === 'threat') {
    if (v >= 90) return POOR;
    if (v >= 75) return BELOW;
    if (v >= 60) return AVERAGE;
    if (v >= 40) return GOOD;
    return EXCELLENT;
  }
  if (v >= 90) return EXCELLENT;
  if (v >= 75) return GOOD;
  if (v >= 60) return AVERAGE;
  if (v >= 40) return BELOW;
  return POOR;
}
